import type { TweenEasing } from "@slot/presentation";

/**
 * The VS battle over its reel (Cocos `vsSpineWildTuning.ts`, the shell's `VsSpineWildTuning` shape): the centre-out
 * reveal of the board, the two Spine clips by `winningIndex`, and the multiplier labels' choreography. The labels run
 * on the runner beside the clip, not on it: their timings are tuned by eye to the baked clip (entrance with the
 * characters, the loser's fade at the clash, the winner to the centre). Heights and offsets are prefab units (the
 * layer scales the board to the reel). The whole battle plays at 1× in every speed mode, slammable.
 */
export interface VsWildTuning {
  /** The board's height at the reveal's start and end (prefab units; the prefab is 958.1 tall). */
  readonly startHeight: number;
  readonly expandHeight: number;
  readonly revealSeconds: number;
  readonly revealEasing: TweenEasing;
  /** The two clips of the `horizontal` skeleton, by `winningIndex`: the top contender wins → [0], the bottom → [1]. */
  readonly animationNames: readonly [string, string];
  /** How far beside its home each label starts (the top from the left, the bottom from the right). */
  readonly entranceOffset: number;
  readonly entranceSeconds: number;
  readonly entranceEasing: TweenEasing;
  /** The wait after the labels land: the clip's clash. */
  readonly clashResolveDelaySeconds: number;
  /** The loser's fade, and the glows' fade as the winner moves. */
  readonly loserFadeSeconds: number;
  readonly preWinnerMoveDelaySeconds: number;
  readonly winnerMoveSeconds: number;
  readonly winnerMoveEasing: TweenEasing;
  /** The beat held after the winner lands. */
  readonly holdSeconds: number;
  /** Appended to each value ("10" → "10x"). */
  readonly multiplierSuffix: string;
}

export const VS_WILD_TUNING: VsWildTuning = {
  startHeight: 0,
  expandHeight: 958,
  revealSeconds: 0.2,
  revealEasing: "quadOut",
  animationNames: ["boy", "bear"],
  entranceOffset: 300,
  entranceSeconds: 0.7,
  entranceEasing: "expoOut",
  clashResolveDelaySeconds: 0.6,
  loserFadeSeconds: 0.25,
  preWinnerMoveDelaySeconds: 0.2,
  winnerMoveSeconds: 0.4,
  winnerMoveEasing: "backOut",
  holdSeconds: 0.3,
  multiplierSuffix: "x",
};
